import { Trans } from '@lingui/react'

import { useSubmitCashBankAccountEligibilityBannerMutation } from '@twisto/api-graphql'
import {
  Banner,
  BannerIcon,
  BannerSubtitle,
  BannerTitle,
} from '@twisto/components/molecules/banner'
import { useFlow } from '@twisto/flow-views/flow/flow.context'
import { BankIcon } from '@twisto/icons'

export const EligibilityBanner = () => {
  const { sessionId } = useFlow()
  const [submitCashBankAccountEligibilityBanner] =
    useSubmitCashBankAccountEligibilityBannerMutation()

  const handleAddNewBankAccount = () =>
    submitCashBankAccountEligibilityBanner({
      variables: {
        auth: {
          sessionId,
        },
      },
    })

  return (
    <Banner size="small" variant="secondary" onClick={handleAddNewBankAccount}>
      <BannerIcon icon={BankIcon} />
      <BannerTitle highlighted>
        <Trans id="flow.cashBankAccountListStep.eligibilityBanner.title" />
      </BannerTitle>
      <BannerSubtitle>
        <Trans id="flow.cashBankAccountListStep.eligibilityBanner.subtile" />
      </BannerSubtitle>
    </Banner>
  )
}
